import React from "react";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
import {
  FiBell,
  FiCheck,
  FiFileText,
  FiUser,
} from "react-icons/fi";

const LoanInProgressPage = ({
  setScreen,
  customerName,
  loanAmount,
}) => {
  const displayName = customerName || "Customer Name";

  const amount = loanAmount
    ? `₹${Number(loanAmount).toLocaleString("en-IN")}`
    : "₹23,800";

  return (
    <section className="fw-screen fw-screen--loan-progress fw-fade">
      <div className="fw-loan-progress__top">
        <div>
            <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>

          <p>Welcome Back</p>

          <h1>{displayName}</h1>
        </div>

        <button
          type="button"
          className="fw-loan-progress__notification"
        >
          <FiBell />
        </button>
      </div>

      <div className="fw-loan-progress__card">
        <h2>In Progress</h2>

        <p>
          We're currently preparing your loan{" "}
          <strong>{amount}</strong> for disbursal.
          Please wait a moment.
        </p>

        <button
          type="button"
          className="fw-btn fw-btn--soft fw-btn--full"
          disabled
        >
          Please Wait...
        </button>
      </div>

      <div className="fw-loan-progress__steps">
        <ProgressStep
          label="Basic Details"
          completed
        />

        <ProgressStep
          label="Employment Details"
          completed
        />

        <ProgressStep
          label="KYC Details"
          completed
        />

        <ProgressStep
          label="Bank Account Details"
          completed
        />

        <ProgressStep
          label="Get Disbursement"
          completed={false}
        />
      </div>

      <div className="fw-loan-progress__bottom">
        <button
          type="button"
          className="is-active"
        //   onClick={() => setScreen("/apply-new/loanInProgress")}
        onClick={() => setScreen("/apply-new/activeLoanHome")}
        >
          <FiFileText />
          <span>Home</span>
        </button>

        <button
          type="button"
          onClick={() => setScreen("/apply-new/paymentHistory")}
        >
          <FiFileText />
          <span>Docs</span>
        </button>

        <button
          type="button"
          onClick={() => setScreen("/apply-new/profile")}
        >
          <FiUser />
          <span>Profile</span>
        </button>
      </div>
    </section>
  );
};

const ProgressStep = ({ label, completed }) => {
  return (
    <div className="fw-loan-progress__step">
      <span className={completed ? "is-completed" : "is-pending"}>
        {completed ? <FiCheck /> : ""}
      </span>

      <p>{label}</p>
    </div>
  );
};

export default LoanInProgressPage;